export const red = "#FB684C";
